import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Flex, Switch as ChakraSwitch } from '@chakra-ui/react';
import { hoverStyles } from './switch.hoverstyles';
export const Switch = React.forwardRef(({ size = 'md', display = 'flex', alignItems = 'center', justifyContent = 'flex-start', ...props }, ref) => {
    return (_jsx(Flex, { __css: hoverStyles, children: _jsx(ChakraSwitch, { size: size, display: display, alignItems: alignItems, justifyContent: justifyContent, ref: ref, ...props }) }));
});
//# sourceMappingURL=switch.js.map